/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { DropdownButton, Menu } from '@neo4j-ndl/react';
import { useRef, useState } from 'react';

const Component = () => {
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Menu
        isOpen={isOpen}
        anchorRef={anchorEl}
        onClose={(_event, _data) => {
          setIsOpen(false);
        }}
        htmlAttributes={{ id: 'category-menu' }}
      >
        <Menu.Group>
          <Menu.CategoryItem>Category 1</Menu.CategoryItem>
          <Menu.Item title="Action 1" onClick={() => alert('Action1')} />
          <Menu.Item title="Action 2" onClick={() => alert('Action2')} />
        </Menu.Group>
        <Menu.Divider />
        <Menu.Group>
          <Menu.Item
            title="Action 3"
            description="Action 3 is disabled"
            isDisabled={true}
            onClick={() => alert('Action3')}
          />
          <Menu.Item
            title="Action 4"
            description="Action 4 is awesome"
            onClick={() => alert('Action4')}
          />
        </Menu.Group>
      </Menu>
      <DropdownButton
        isOpen={isOpen}
        onClick={() => setIsOpen(true)}
        ref={anchorEl}
        aria-haspopup="menu"
      >
        Open Menu
      </DropdownButton>
    </>
  );
};

export default Component;
